import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, AlertCircle } from "lucide-react";
import api from "@/lib/api";

// Landing page after returning from the Stripe Identity hosted flow. Verification
// is asynchronous - the signed webhook is authoritative - so we just poll status
// for display and route the member back to their wallet.
export default function KycComplete() {
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "processing", kyc_verified: false });

  useEffect(() => {
    let active = true;
    const poll = () => api.get("/kyc/status")
      .then((r) => { if (active) setState(r.data); })
      .catch(() => {});
    poll();
    const id = setInterval(poll, 3000);
    return () => { active = false; clearInterval(id); };
  }, []);

  const verified = state.kyc_verified;
  const needsInput = state.status === "requires_input";

  return (
    <div className="max-w-md mx-auto animate-slide-up text-center py-16" data-testid="kyc-complete">
      {verified ? (
        <>
          <ShieldCheck size={48} className="text-green-400 mx-auto mb-4" />
          <h1 className="font-heading text-4xl tracking-tight mb-2">Identity verified</h1>
          <p className="text-race-sub text-sm mb-6">You're all set - you can now withdraw your balance.</p>
        </>
      ) : needsInput ? (
        <>
          <AlertCircle size={48} className="text-race-red mx-auto mb-4" />
          <h1 className="font-heading text-4xl tracking-tight mb-2">Another attempt needed</h1>
          <p className="text-race-sub text-sm mb-6">Your verification couldn't be completed. You can try again from your wallet.</p>
        </>
      ) : (
        <>
          <Loader2 size={48} className="text-race-volt mx-auto mb-4 animate-spin" />
          <h1 className="font-heading text-4xl tracking-tight mb-2">Verification submitted</h1>
          <p className="text-race-sub text-sm mb-6">We're confirming your identity with Stripe. This usually takes a moment.</p>
        </>
      )}
      <button onClick={() => navigate("/racing-team")} data-testid="kyc-complete-back"
        className="bg-race-volt text-race-bg font-heading text-xl tracking-wide px-8 py-3 rounded-sm hover:opacity-90 transition-opacity">
        BACK TO WALLET →
      </button>
    </div>
  );
}
